import React, { FC, useState } from 'react';
import {
  ForgeButton,
  ForgeDialog,
  ForgeIcon,
  ForgeIconButton,
  ForgeScaffold,
  ForgeToolbar
} from '@tylertech/forge-react';

import { showSuccessToastNow } from 'common/components/ToastNotification/Toastmaster';
import './index.scss';
import { useEscapeKey } from 'common/visualizations/views/agGridReact/customHooks/useEscapeKey';
import { I18n } from 'common/visualizations';
import AttachmentSection from './components/Attachment/AttachmentSection';
import { AttachmentConfiguration } from './types/attachment';
import { tablesFromStoryData } from './components/Attachment/helpers';
import { DEFAULT_ATTACHMENT_CONFIG } from './constants';
import { View } from 'common/types/view';
import FrequencySelector from '../FrequencySelector';
import { FrequencyConfig } from 'common/types/frequencySelector/frequencySelector';
import { frequencyConfigDefaulValues } from './constants/defaultVal';

const scope = 'shared.components.schedule_send_report.modal';

export interface ScheduleSendProps {
  view: View;
  onDismiss: () => void;
  scheduledSendModalVisible: boolean;
  setScheduledSendModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const ScheduleSendReportModal: FC<ScheduleSendProps> = (props) => {
  const { view, onDismiss, scheduledSendModalVisible, setScheduledSendModalVisible } = props;
  const [attachmentConfig, setAttachmentConfig] = useState<AttachmentConfiguration[]>([
    {
      value: DEFAULT_ATTACHMENT_CONFIG.value,
      format: DEFAULT_ATTACHMENT_CONFIG.format,
      icon: DEFAULT_ATTACHMENT_CONFIG.icon
    }
  ]);
  const [frequencyConfig, setFrequencyConfig] = useState<FrequencyConfig>(frequencyConfigDefaulValues);

  // If a user clicks the esc button, we are closing the modal
  useEscapeKey(onDismiss, scheduledSendModalVisible);

  async function onSaveConfiguration() {
    showSuccessToastNow(I18n.t('success_toast', { scope }));
    setScheduledSendModalVisible(false);
  }

  return (
    <ForgeDialog
      open={scheduledSendModalVisible}
      on-forge-dialog-close={onDismiss}
      persistent
      data-testid="schedule-send-dialog"
      aria-labelledby="schedule-send-modal-title"
    >
      <ForgeScaffold className="schedule-send-modal">
        <div slot="header">
          <ForgeToolbar className="dialog-header tyl-typography">
            <h1
              slot="start"
              className="forge-typography--heading4"
              id="schedule-send-modal-title"
              data-testid="schedule-send-modal-title"
            >
              {I18n.t('title', { scope })}
            </h1>
            <ForgeIconButton densityLevel={3} slot="end">
              <ForgeIcon name="close" onClick={onDismiss} />
            </ForgeIconButton>
          </ForgeToolbar>
        </div>

        <div slot="body" className="schedule-send-modal-body">
          <AttachmentSection
            tableList={tablesFromStoryData(view)}
            attachmentConfig={attachmentConfig}
            setAttachmentConfig={setAttachmentConfig}
          />
          <FrequencySelector
            value={frequencyConfig}
            setValue={setFrequencyConfig}
            className="container-border"
          />
        </div>

        <div slot="footer" className="schedule-send-footer">
          <ForgeToolbar inverted={true} className="footer-toolbar">
            <div slot="end">
              <ForgeButton variant="outlined" id="cancel-button" onClick={onDismiss}>
                {I18n.t('cancel', { scope })}
              </ForgeButton>
              <ForgeButton variant="raised" id="save-button" onClick={onSaveConfiguration}>
                <ForgeIcon
                  name="send_clock"
                  aria-hidden="false"
                  external
                  external-type="extended"
                ></ForgeIcon>
                {I18n.t('title', { scope })}
              </ForgeButton>
            </div>
          </ForgeToolbar>
        </div>
      </ForgeScaffold>
    </ForgeDialog>
  );
};

export default ScheduleSendReportModal;
